/**
 * ToDo API
 * An ASP.NET Core Web API for managing ToDo items
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DataChangesNeededForOptimizationResponseModel { 
    jobIdsWithMoreThanOneVisit?: { [key: string]: number; };
    missingAddressJobIds?: Array<string>;
    tooManyAddressesJobIds?: Array<string>;
    homeAddressNotPassedIn?: boolean;
    homeAddressCannotBeGeocoded?: boolean;
    jobIdsWithAddressThatCannotBeGeocoded?: Array<string>;
}

